import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminRoute from './components/AdminRoute';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';

// Pages
import Account from './pages/Account';
import CategoryDetailsPage from './pages/CategoryDetailsPage';
import Checkout from './pages/Checkout';
import Login from './pages/Login';
import ProductDetailsPage from './pages/ProductDetailsPage';
import Register from './pages/Register';
import StoreAboutPage from './pages/StoreAboutPage';
import StoreHomePage from './pages/StoreHomePage';
import StoresPage from './pages/StoresPage';

// Admin Pages
import AdminLayout from './components/admin/AdminLayout';
import AdminAboutPage from './features/about/pages/AdminAboutPage';
import Dashboard from './pages/admin/Dashboard';
import Profile from './pages/admin/Profile';
import StoreFormPage from './pages/admin/StoreForm';
import StoreList from './pages/admin/StoreList';
import StoreManagement from './pages/admin/StoreManagement';

// Category Pages
import CategoryManagementPage from './features/categories/pages/CategoryManagementPage';
import StoreCategoriesPage from './features/categories/pages/StoreCategoriesPage';

// Product Pages
import ProductManagementPage from './features/products/pages/ProductManagementPage';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<StoresPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/stores/:slug" element={<StoreHomePage />} />
            <Route path="/stores/:slug/about" element={<StoreAboutPage />} />
            <Route path="/stores/:slug/categories/:categoryId" element={<CategoryDetailsPage />} />
            <Route path="/products/:productId" element={<ProductDetailsPage />} />
            <Route path="/stores/:slug/categories" element={<StoreCategoriesPage />} />
            <Route 
              path="/stores/:slug/account" 
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              } 
            />
            <Route path="/search" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Search Page</h2>
                <p className="text-gray-600">Search functionality coming soon...</p>
              </div>
            </div>} />
            <Route path="/cart" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Shopping Cart</h2>
                <p className="text-gray-600">Cart functionality coming soon...</p>
              </div>
            </div>} />
            <Route path="/categories" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">All Categories</h2>
                <p className="text-gray-600">Categories page coming soon...</p>
              </div>
            </div>} />
            <Route path="/products" element={<div className="min-h-screen bg-gray-50 flex items-center justify-center">
              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">All Products</h2>
                <p className="text-gray-600">Products page coming soon...</p>
              </div>
            </div>} />
            
            {/* Protected Routes */}
            <Route 
              path="/account" 
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              } 
            />
            
            <Route 
              path="/checkout" 
              element={
                <ProtectedRoute>
                  <Checkout />
                </ProtectedRoute>
              } 
            />
            
            {/* Admin Routes */}
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <Dashboard />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/dashboard" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <Dashboard />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <StoreList />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/create" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <StoreFormPage />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/:id/edit" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <StoreFormPage />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/:slug" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <StoreManagement />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/:slug/about" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <AdminAboutPage />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/:slug/categories" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <CategoryManagementPage />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/:slug/categories" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <CategoryManagementPage />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/stores/:slug/products" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <ProductManagementPage />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            {/* Additional Admin Routes */}
            <Route 
              path="/admin/products" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                      <div className="text-center">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Products Management</h2>
                        <p className="text-gray-600">Products management coming soon...</p>
                      </div>
                    </div>
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/orders" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                      <div className="text-center">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Orders Management</h2>
                        <p className="text-gray-600">Orders management coming soon...</p>
                      </div>
                    </div>
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            <Route 
              path="/admin/profile" 
              element={
                <AdminRoute>
                  <AdminLayout>
                    <Profile />
                  </AdminLayout>
                </AdminRoute>
              } 
            />
            
            {/* Catch all route */}
            <Route path="*" element={<StoresPage />} />
          </Routes>
          <ToastContainer position="top-center" />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
